const santos = [
  {
    id: 1,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 25/26 - Uniforme 1",
    aliases: ["santos", "alvinegro", "peixe", "2025", "santos 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/santos/25-26-01/uni0.jpg",
      "/images/brasil/serie-a/santos/25-26-01/uni1.jpg",
      "/images/brasil/serie-a/santos/25-26-01/uni2.jpg",
      "/images/brasil/serie-a/santos/25-26-01/uni3.jpg",
      "/images/brasil/serie-a/santos/25-26-01/uni4.jpg",
    ],
  },
  {
    id: 2,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 25/26 - Uniforme 1 (Feminino)",
    aliases: [
      "santos",
      "alvinegro",
      "peixe",
      "2025",
      "santos 2025",
      "feminino",
      "santos feminino",
      "feminino santos",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/santos/25-26-01-f/uni0.jpg",
      "/images/brasil/serie-a/santos/25-26-01-f/uni1.jpg",
      "/images/brasil/serie-a/santos/25-26-01-f/uni2.jpg",
      "/images/brasil/serie-a/santos/25-26-01-f/uni3.jpg",
      "/images/brasil/serie-a/santos/25-26-01-f/uni4.jpg",
    ],
  },
  {
    id: 3,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 25/26 - Uniforme 2",
    aliases: ["santos", "alvinegro", "peixe", "2025", "santos 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/santos/25-26-02/uni0.jpg",
      "/images/brasil/serie-a/santos/25-26-02/uni1.jpg",
      "/images/brasil/serie-a/santos/25-26-02/uni2.jpg",
      "/images/brasil/serie-a/santos/25-26-02/uni3.jpg",
      "/images/brasil/serie-a/santos/25-26-02/uni4.jpg",
    ],
  },
  {
    id: 4,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 25/26 - Uniforme 3",
    aliases: ["santos", "alvinegro", "peixe", "2025", "santos 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/santos/25-26-03/uni0.jpg",
      "/images/brasil/serie-a/santos/25-26-03/uni1.jpg",
      "/images/brasil/serie-a/santos/25-26-03/uni2.jpg",
      "/images/brasil/serie-a/santos/25-26-03/uni3.jpg",
      "/images/brasil/serie-a/santos/25-26-03/uni4.jpg",
    ],
  },
  {
    id: 5,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 25/26 - Uniforme de Goleiro (Preta)",
    aliases: ["santos", "alvinegro", "peixe", "2025", "santos 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/santos/25-26-04-gp/uni0.jpg",
      "/images/brasil/serie-a/santos/25-26-04-gp/uni1.jpg",
      "/images/brasil/serie-a/santos/25-26-04-gp/uni2.jpg",
      "/images/brasil/serie-a/santos/25-26-04-gp/uni3.jpg",
      "/images/brasil/serie-a/santos/25-26-04-gp/uni4.jpg",
    ],
  },
  {
    id: 6,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 25/26 - Uniforme de Goleiro (Azul)",
    aliases: ["santos", "alvinegro", "peixe", "2025", "santos 2025"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/santos/25-26-05-ga/uni0.jpg",
      "/images/brasil/serie-a/santos/25-26-05-ga/uni1.jpg",
      "/images/brasil/serie-a/santos/25-26-05-ga/uni2.jpg",
      "/images/brasil/serie-a/santos/25-26-05-ga/uni3.jpg",
      "/images/brasil/serie-a/santos/25-26-05-ga/uni4.jpg",
    ],
  },
  {
    id: 7,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 24/25 - Uniforme 1",
    aliases: ["santos", "alvinegro", "peixe", "2024", "santos 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/santos/24-25-01/uni0.jpg",
      "/images/brasil/serie-a/santos/24-25-01/uni1.jpg",
      "/images/brasil/serie-a/santos/24-25-01/uni2.jpg",
      "/images/brasil/serie-a/santos/24-25-01/uni3.jpg",
      "/images/brasil/serie-a/santos/24-25-01/uni4.jpg",
    ],
  },
  {
    id: 8,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 24/25 - Uniforme 2",
    aliases: ["santos", "alvinegro", "peixe", "2024", "santos 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/santos/24-25-02/uni0.jpg",
      "/images/brasil/serie-a/santos/24-25-02/uni1.jpg",
      "/images/brasil/serie-a/santos/24-25-02/uni2.jpg",
      "/images/brasil/serie-a/santos/24-25-02/uni3.jpg",
      "/images/brasil/serie-a/santos/24-25-02/uni4.jpg",
    ],
  },
  {
    id: 9,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 24/25 - Uniforme Edição Especial",
    aliases: ["santos", "alvinegro", "peixe", "2024", "santos 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/santos/24-25-05-es/uni0.jpg",
      "/images/brasil/serie-a/santos/24-25-05-es/uni1.jpg",
      "/images/brasil/serie-a/santos/24-25-05-es/uni2.jpg",
      "/images/brasil/serie-a/santos/24-25-05-es/uni3.jpg",
      "/images/brasil/serie-a/santos/24-25-05-es/uni4.jpg",
    ],
  },
  {
    id: 10,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 24/25 - Uniforme de Pré Jogo (Cinza) ",
    aliases: ["santos", "alvinegro", "peixe", "2024", "santos 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/santos/24-25-06-pjc/uni0.jpg",
      "/images/brasil/serie-a/santos/24-25-06-pjc/uni1.jpg",
      "/images/brasil/serie-a/santos/24-25-06-pjc/uni2.jpg",
      "/images/brasil/serie-a/santos/24-25-06-pjc/uni3.jpg",
      "/images/brasil/serie-a/santos/24-25-06-pjc/uni4.jpg",
    ],
  },
  {
    id: 11,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 24/25 - Uniforme de Pré Jogo (Azul) ",
    aliases: ["santos", "alvinegro", "peixe", "2024", "santos 2024"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/santos/24-25-pja/uni0.jpg",
      "/images/brasil/serie-a/santos/24-25-pja/uni1.jpg",
      "/images/brasil/serie-a/santos/24-25-pja/uni2.jpg",
      "/images/brasil/serie-a/santos/24-25-pja/uni3.jpg",
      "/images/brasil/serie-a/santos/24-25-pja/uni4.jpg",
    ],
  },
  {
    id: 12,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 24/25 - Uniforme 1 (Feminino)",
    aliases: [
      "santos",
      "alvinegro",
      "peixe",
      "2024",
      "santos 2024",
      "feminino",
      "santos feminino",
      "feminino santos",
    ],
    tipo: "feminino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/santos/24-25-01-f/uni0.jpg",
      "/images/brasil/serie-a/santos/24-25-01-f/uni1.jpg",
      "/images/brasil/serie-a/santos/24-25-01-f/uni2.jpg",
      "/images/brasil/serie-a/santos/24-25-01-f/uni3.jpg",
      "/images/brasil/serie-a/santos/24-25-01-f/uni4.jpg",
    ],
  },
  {
    id: 13,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 23/24 - Uniforme Edição Especial (Roxa)",
    aliases: ["santos", "alvinegro", "peixe", "2023", "santos 2023"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/santos/23-24-00-r/uni0.jpeg",
      "/images/brasil/serie-a/santos/23-24-00-r/uni1.jpeg",
      "/images/brasil/serie-a/santos/23-24-00-r/uni2.jpeg",
      "/images/brasil/serie-a/santos/23-24-00-r/uni3.jpeg",
      "/images/brasil/serie-a/santos/23-24-00-r/uni4.jpeg",
    ],
  },
  {
    id: 14,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 22/23 - Uniforme 2",
    aliases: ["santos", "alvinegro", "peixe", "2022", "santos 2022"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/santos/22-23-02/uni0.jpg",
      "/images/brasil/serie-a/santos/22-23-02/uni1.jpg",
      "/images/brasil/serie-a/santos/22-23-02/uni2.jpg",
      "/images/brasil/serie-a/santos/22-23-02/uni3.jpg",
      "/images/brasil/serie-a/santos/22-23-02/uni4.jpg",
    ],
  },
  {
    id: 15,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 21/22 - Uniforme 1",
    aliases: ["santos", "alvinegro", "peixe", "2021", "santos 2021"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/santos/21-22-01/uni0.jpg",
      "/images/brasil/serie-a/santos/21-22-01/uni1.jpg",
      "/images/brasil/serie-a/santos/21-22-01/uni2.jpg",
      "/images/brasil/serie-a/santos/21-22-01/uni3.jpg",
      "/images/brasil/serie-a/santos/21-22-01/uni4.jpg",
    ],
  },
  {
    id: 16,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 21/22 - Uniforme 2",
    aliases: ["santos", "alvinegro", "peixe", "2021", "santos 2021"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/santos/21-22-02/uni0.jpg",
      "/images/brasil/serie-a/santos/21-22-02/uni1.jpg",
      "/images/brasil/serie-a/santos/21-22-02/uni2.jpg",
      "/images/brasil/serie-a/santos/21-22-02/uni3.jpg",
      "/images/brasil/serie-a/santos/21-22-02/uni4.jpg",
    ],
  },
  {
    id: 17,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 21/22 - Uniforme 3",
    aliases: ["santos", "alvinegro", "peixe", "2021", "santos 2021"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/santos/21-22-03/uni0.jpg",
      "/images/brasil/serie-a/santos/21-22-03/uni1.jpg",
      "/images/brasil/serie-a/santos/21-22-03/uni2.jpg",
      "/images/brasil/serie-a/santos/21-22-03/uni3.jpg",
      "/images/brasil/serie-a/santos/21-22-03/uni4.jpg",
    ],
  },
  {
    id: 18,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 21/22 - Uniforme de Goleiro (Preta)",
    aliases: ["santos", "alvinegro", "peixe", "2021", "santos 2021"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/santos/21-22-05-gp/uni0.jpg",
      "/images/brasil/serie-a/santos/21-22-05-gp/uni1.jpg",
      "/images/brasil/serie-a/santos/21-22-05-gp/uni2.jpg",
      "/images/brasil/serie-a/santos/21-22-05-gp/uni3.jpg",
      "/images/brasil/serie-a/santos/21-22-05-gp/uni4.jpg",
    ],
  },
  {
    id: 19,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 20/21 - Uniforme 1",
    aliases: ["santos", "alvinegro", "peixe", "2020", "santos 2020"],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/santos/20-21-01/uni0.jpg",
      "/images/brasil/serie-a/santos/20-21-01/uni1.jpg",
      "/images/brasil/serie-a/santos/20-21-01/uni2.jpg",
      "/images/brasil/serie-a/santos/20-21-01/uni3.jpg",
      "/images/brasil/serie-a/santos/20-21-01/uni4.jpg",
    ],
  },
  {
    id: 20,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 12/13 - Uniforme 2 Retro",
    aliases: [
      "santos",
      "alvinegro",
      "peixe",
      "retro",
      "santos retro",
      "retro santos",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/santos/12-13-02-rt/uni0.jpg",
      "/images/brasil/serie-a/santos/12-13-02-rt/uni1.jpg",
      "/images/brasil/serie-a/santos/12-13-02-rt/uni2.jpg",
      "/images/brasil/serie-a/santos/12-13-02-rt/uni3.jpg",
      "/images/brasil/serie-a/santos/12-13-02-rt/uni4.jpg",
    ],
  },
  {
    id: 21,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 12/13 - Uniforme 3 Retro",
    aliases: [
      "santos",
      "alvinegro",
      "peixe",
      "retro",
      "santos retro",
      "retro santos",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/santos/12-13-03-rt/uni0.jpg",
      "/images/brasil/serie-a/santos/12-13-03-rt/uni1.jpg",
      "/images/brasil/serie-a/santos/12-13-03-rt/uni2.jpg",
      "/images/brasil/serie-a/santos/12-13-03-rt/uni3.jpg",
      "/images/brasil/serie-a/santos/12-13-03-rt/uni4.jpg",
    ],
  },
  {
    id: 22,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 11/12 - Calção 1 Retro",
    aliases: [
      "santos",
      "alvinegro",
      "peixe",
      "retro",
      "santos retro",
      "retro santos",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/santos/11-12-01-c/uni0.jpg",
      "/images/brasil/serie-a/santos/11-12-01-c/uni1.jpg",
      "/images/brasil/serie-a/santos/11-12-01-c/uni2.jpg",
      "/images/brasil/serie-a/santos/11-12-01-c/uni3.jpg",
      "/images/brasil/serie-a/santos/11-12-01-c/uni4.jpg",
    ],
  },
  {
    id: 23,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 11/12 - Uniforme Edição Especial Retro (Rosa)",
    aliases: [
      "santos",
      "alvinegro",
      "peixe",
      "retro",
      "santos retro",
      "retro santos",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/santos/11-12-00-rtr/uni0.jpg",
      "/images/brasil/serie-a/santos/11-12-00-rtr/uni1.jpg",
      "/images/brasil/serie-a/santos/11-12-00-rtr/uni2.jpg",
      "/images/brasil/serie-a/santos/11-12-00-rtr/uni3.jpg",
      "/images/brasil/serie-a/santos/11-12-00-rtr/uni4.jpg",
    ],
  },
  {
    id: 24,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 11/12 - Uniforme 2 Retro",
    aliases: [
      "santos",
      "alvinegro",
      "peixe",
      "retro",
      "santos retro",
      "retro santos",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/santos/11-12-02-rt/uni0.jpg",
      "/images/brasil/serie-a/santos/11-12-02-rt/uni1.jpg",
      "/images/brasil/serie-a/santos/11-12-02-rt/uni2.jpg",
      "/images/brasil/serie-a/santos/11-12-02-rt/uni3.jpg",
      "/images/brasil/serie-a/santos/11-12-02-rt/uni4.jpg",
    ],
  },
  {
    id: 25,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 98/99 - Uniforme 2 Retro",
    aliases: [
      "santos",
      "alvinegro",
      "peixe",
      "retro",
      "santos retro",
      "retro santos",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/santos/98-99-02-rt/uni0.jpg",
      "/images/brasil/serie-a/santos/98-99-02-rt/uni1.png",
      "/images/brasil/serie-a/santos/98-99-02-rt/uni2.jpg",
      "/images/brasil/serie-a/santos/98-99-02-rt/uni3.jpg",
      "/images/brasil/serie-a/santos/98-99-02-rt/uni4.jpg",
    ],
  },
  {
    id: 26,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 93/94 - Uniforme 1 Retro",
    aliases: [
      "santos",
      "alvinegro",
      "peixe",
      "retro",
      "santos retro",
      "retro santos",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/santos/93-94-01-rt/uni0.jpg",
      "/images/brasil/serie-a/santos/93-94-01-rt/uni1.jpg",
      "/images/brasil/serie-a/santos/93-94-01-rt/uni2.jpg",
      "/images/brasil/serie-a/santos/93-94-01-rt/uni3.jpg",
      "/images/brasil/serie-a/santos/93-94-01-rt/uni4.jpg",
    ],
  },
  {
    id: 27,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos 55/56 - Uniforme 2 Retro",
    aliases: [
      "santos",
      "alvinegro",
      "peixe",
      "retro",
      "santos retro",
      "retro santos",
    ],
    tipo: "masculino",
    categoria: "oficial",
    edicaoEspecial: true,
    imagens: [
      "/images/brasil/serie-a/santos/55-56-02-rt/uni0.jpg",
      "/images/brasil/serie-a/santos/55-56-02-rt/uni1.jpg",
      "/images/brasil/serie-a/santos/55-56-02-rt/uni2.jpg",
      "/images/brasil/serie-a/santos/55-56-02-rt/uni3.jpg",
      "/images/brasil/serie-a/santos/55-56-02-rt/uni4.jpg",
    ],
  },
  {
    id: 28,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos - Jaqueta (Branca/Preta)",
    aliases: [
      "santos",
      "alvinegro",
      "peixe",
      "jaqueta",
      "santos jaqueta",
      "jaqueta santos",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/santos/jbp/uni0.jpg",
      "/images/brasil/serie-a/santos/jbp/uni1.jpg",
      "/images/brasil/serie-a/santos/jbp/uni2.jpg",
      "/images/brasil/serie-a/santos/jbp/uni3.jpg",
      "/images/brasil/serie-a/santos/jbp/uni4.jpg",
    ],
  },
  {
    id: 29,
    pais: "brasil",
    liga: "serie-a",
    time: "santos",
    nome: "Santos - Jaqueta (Preta)",
    aliases: [
      "santos",
      "alvinegro",
      "peixe",
      "jaqueta",
      "santos jaqueta",
      "jaqueta santos",
    ],
    tipo: "masculino",
    categoria: "jaqueta",
    edicaoEspecial: false,
    imagens: [
      "/images/brasil/serie-a/santos/jp/uni0.png",
      "/images/brasil/serie-a/santos/jp/uni1.png",
      "/images/brasil/serie-a/santos/jp/uni2.png",
      "/images/brasil/serie-a/santos/jp/uni3.png",
      "/images/brasil/serie-a/santos/jp/uni4.png",
    ],
  },
];

export default santos;
